import React, { PureComponent } from "react";

import styles from "./Album.local.scss";

export default class AlbumFetchingComponent extends PureComponent {
  render() {
    return <div className={styles.album} />;
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Common/AlbumFetching/AlbumFetchingComponent.js